module.exports = __webpack_public_path__ + "img/how-to_image01.8e2c5eac.png";